import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-boolean-status',
    templateUrl: './boolean-status.component.html',
    styleUrls: ['./boolean-status.component.scss']
})
export class BooleanStatusComponent implements OnInit {
    @Input()
    status: boolean;

    @Input()
    label?: string;

    interval: NodeJS.Timeout;

    constructor() {}

    ngOnInit(): void {}

    getStatusClass(): string {
        return _.isBoolean(this.status) ? (this.status ? 'status-green' : 'status-red') : 'status-gray';
    }

    getStatusText(): string {
        return _.isBoolean(this.status) ? (this.status ? 'On' : 'Off') : 'No data';
    }

    ngOnDestroy() {
        clearInterval(this.interval);
    }
}
